import { render, staticRenderFns } from "./StudentHeaderNew.vue?vue&type=template&id=6e5ced06&scoped=true&"
import script from "./StudentHeaderNew.vue?vue&type=script&lang=js&"
export * from "./StudentHeaderNew.vue?vue&type=script&lang=js&"
import style0 from "./StudentHeaderNew.vue?vue&type=style&index=0&id=6e5ced06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5ced06",
  null
  
)

export default component.exports